(() => {
  class ProductUpsel extends HTMLElement {
    connectedCallback() {
      this.formId = this.getAttribute('data-product-form-id');
      if (!this.formId) return;

      const form = document.getElementById(this.formId);
      if (!form) return;

      const submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn) return;

      const cleanBtn = submitBtn.cloneNode(true);
      submitBtn.replaceWith(cleanBtn);

      let inFlight = false;

      cleanBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (inFlight) return;
        inFlight = true;
        cleanBtn.disabled = true;

        try {
          const variantIds = this.getSelectedVariantIds();
          if (variantIds.length) {
            await this.addUpsellsToCart(variantIds);
          }

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(cleanBtn);
          } else {
            form.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}));
          }
        } catch (err) {
          console.error('[product-upsell] error:', err);
          if (typeof form.requestSubmit === 'function') form.requestSubmit(cleanBtn);
        } finally {
          inFlight = false;
        }
      });
    }

    getSelectedVariantIds() {
      return Array.from(this.querySelectorAll('input[type="checkbox"][data-variant-id]:checked'))
        .map((el) => el.getAttribute('data-variant-id'))
        .filter(Boolean);
    }

    async addUpsellsToCart(variantIds) {
      for (const id of variantIds) {
        await this.addOne(id);
      }
    }

    async addOne(variantId) {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          items: [{id: Number(variantId), quantity: 1}],
        }),
      });

      if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`Failed to add upsell variant ${variantId}. ${text}`);
      }

      return res.json();
    }
  }

  if (!customElements.get('product-upsell')) {
    customElements.define('product-upsell', ProductUpsel);
  }

  if (!customElements.get('upsell-item')) {
    customElements.define('upsell-item', class UpsellItem extends HTMLElement {
    });
  }
})();